import type { StoreJsonResponse } from "./common/store.core";
import { Store } from "./common/store.core";
import { getProcoreCompanyIdFromURL } from "@/lib/utils/url";
import { HttpMethod } from "@/lib/utils/http-methods";
import { authManager } from "@/lib/managers/auth-manager";

export type GetProcoreEnvironmentResponse = {
   company_id: string;
   company_name: string;
   user_id: string;
   locale: string;
   currency_symbol: string;
   currency_display: string;
   currency_iso_code: string;
   time_zone: string;
   date_format: string;
};

type LogAnalyticsEventPayload = {
   key: string;
   properties: Record<string, any>;
};
export abstract class ProcoreStore extends Store {
   static getProcoreCurrencyConfiguration(): StoreJsonResponse<GetProcoreEnvironmentResponse> {
      const procoreCompanyId = getProcoreCompanyIdFromURL();
      return this.requestProcoreJson({
         url: `/rest/v1.0/companies/${procoreCompanyId}/procore_environment`,
         method: HttpMethod.GET,
      });
   }

   static logAnalyticsEvent(payload: LogAnalyticsEventPayload): void {
      const { key, properties } = payload;
      const user = authManager.authedUser();
      // These are the default properteis that will be sent with every frontend
      // analytics event.
      const defaultProperties = {
         wfp_company_id: user?.companyId(),
         wfp_company_name: user?.baggage()?.company_name,
         wfp_user_id: user?.id,
         wfp_user_email: user?.email(),
      };
      const finalProperties = {
         ...defaultProperties,
         ...properties,
      };
      const finalPayload = {
         key,
         properties: finalProperties,
      };
      this.requestProcoreJson({
         url: `/rest/v1.0/analytic_events`,
         method: HttpMethod.POST,
         body: finalPayload,
      });
   }
}
